import {Component,ElementRef,Input,OnDestroy,OnInit,Output,ViewChild,EventEmitter} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { FieldsetModule } from 'primeng/fieldset';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { KeyFilterModule } from 'primeng/keyfilter';

// Importando os componentes standalone que já foram convertidos
import { AtividadeAnexosComponent } from '../atividade-anexos/atividade-anexos.component';
import { AtividadeEventsComponent } from '../atividade-events/atividade-events.component';
import { AtividadeImagesComponent } from '../atividade-images/atividade-images.component';
import { AtividadeOsVinculadaComponent } from '../atividade-os-vinculada/atividade-os-vinculada.component';
import { GoogleMapsComponent } from '@/shared/components/google-maps/google-maps.component';

// Módulos que ainda não foram convertidos para standalone (comentados)
// import { AtividadeAcionamentoModule } from '@/features/atividade-acionamento/atividade-acionamento.module';
// import { AtividadeTipoModule } from '@/features/atividade-tipo/atividade-tipo.module';
// import { CaracteristicaModule } from '@/features/caracteristica/caracteristica.module';
// import { HierarquiaModule } from '@/features/hierarquia/hierarquia.module';

import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AcionamentoTipo } from '../models/acionamento-tipo';
import { AtividadeClasse } from '../models/atividade-classe';
import {AtividadeDetalhe,AtividadeGeralImagemViewModel,AtividadeInstalacao,} from '../models/atividade-detalhe';
import { AtividadeStatusModel } from '@/features/atividade-status/models/atividade-status.model';
import { AtividadeClassificacao } from '../models/atividade-classificacao';
import { AtividadeTipo } from '@/models/tipo-servico';
import { AtividadeTipoService } from '@/features/atividade-tipo/services/atividade-tipo.service';
import { CaracteristicaService } from '@/features/caracteristica-equipe/caracteristica/caracteristica.service';
import { ComboBase } from '@/models/comboModel';
// import { ClienteService } from '@/features/cliente/cliente.service';
// import { ProdutoService } from '@/core/services/produto/produto.service';
import { GoogleApiService } from '@/core/service/googleApi.service';
import { UserService } from '@/core/service/user.service';
import { AtividadeFluxoTransicaoPorStatus } from '../models/atividade-fluxo-transicao-por-status';
import { MessageService, TreeNode } from 'primeng/api';
import { AtividadeEvents } from '../models/atividade-events';
// import { AtividadeCaracteristicaService } from '@/core/services/atividade/atividade.service';
import { AtividadeService } from '../atividade.service';
import { UtilService } from '@/core/services/util.service';
import { ToiMidiaItem } from '@/features/toi/models/toi-detalhe.model';
import { getToiMidiaKey } from '@/features/toi/utils/toi-midia.util';
declare var google: any;

@Component({
    selector: 'mf-atividade-form',
    templateUrl: './atividade-form.component.html',
    styleUrls: ['./atividade-form.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        InputTextModule,
        ButtonModule,
        FieldsetModule,
        SelectModule,
        DialogModule,
        ToastModule,
        TableModule,
        InputNumberModule,
        KeyFilterModule,
        // Componentes standalone já convertidos
        AtividadeAnexosComponent,
        AtividadeEventsComponent,
        AtividadeImagesComponent,
        AtividadeOsVinculadaComponent,
        GoogleMapsComponent,
        // Módulos que ainda não foram convertidos para standalone (comentados)
        // AtividadeAcionamentoModule,
        // AtividadeTipoModule,
        // CaracteristicaModule,
        // HierarquiaModule,
    ],
    providers: [
        MessageService,
        AtividadeService,
        AtividadeTipoService,
        CaracteristicaService,
        GoogleApiService
    ]
})
export class AtividadeFormComponent implements OnInit, OnDestroy {
  // #region "Properties"
  imageContent: boolean = false;
  loadImage: boolean = true;
  showImages: boolean = false;
  private _imagesFieldsetCollapsed: boolean = true;

  get imagesFieldsetCollapsed(): boolean {
    return this._imagesFieldsetCollapsed;
  }

  set imagesFieldsetCollapsed(value: boolean) {
    const wasCollapsed = this._imagesFieldsetCollapsed;
    this._imagesFieldsetCollapsed = value;
    this.showImages = !value;

    // Só carrega as imagens se o fieldset foi expandido (mudou de true para false)
    // e não se foi apenas inicializado
    if (!value && wasCollapsed && this.loadImage && this.atividade?.imagens) {
      console.log('Fieldset expanded - loading images', this.atividade.imagens);
      this.verificarImagens(this.atividade.imagens);
    }
  }

  @Input() tipoAcionamento: string = '';
  disabled: boolean = true;
  @Input() enderecoCliente: string = '';
  latitudeCliente: number = 0;
  longitudeCliente: number = 0;
  @ViewChild('enderecoInput') enderecoInput!: ElementRef<HTMLInputElement>;
  @ViewChild('latitudeInput') latitudeInput!: ElementRef<HTMLInputElement>;
  @ViewChild('longitudeInput') longitudeInput!: ElementRef<HTMLInputElement>;

  atividadeAddForm!: FormGroup;
  atividadeDetalhe!: AtividadeGeralImagemViewModel;
  atividadeDetalhe$!: Observable<AtividadeDetalhe>;
  atividade!: AtividadeDetalhe;
  @Input() idAtividade: number = 0;
  @Input() toiMidias: ToiMidiaItem[] = [];
  @Input() midiasOcultasPdf: Set<string> = new Set<string>();

  listaAcionamentos: AcionamentoTipo[] = [];
  selectedItemAcionamentoTipo!: AcionamentoTipo;

  listaStatus: AtividadeStatusModel[] = [];
  selectedItemStatus!: AtividadeStatusModel;

  listaAtividadeClasse: AtividadeClasse[] = [];

  listaAtividadeClassificacao: AtividadeClassificacao[] = [];
  listaAtividadeClassificacaoFull: AtividadeClassificacao[] = [];
  selectedItemAtividadeClassificacao!: AtividadeClassificacao;

  listaAtividadeTipo: AtividadeTipo[] = [];
  selectedItemAtividadeTipo!: AtividadeTipo;

  listaProduto: ComboBase[] = [];
  listaProdutoFull: ComboBase[] = [];
  selectedItemProduto!: ComboBase;

  listaCaracteristica: ComboBase[] = [];
  listaCaracteristicaFull: ComboBase[] = [];
  selectedItemCaracteristica!: ComboBase;

  idHierarquia: number = 0;
  dialogHierarquiaVisible: boolean = false;
  hierarquiaLabel: string = '';

  listaCliente: ComboBase[] = [];
  selectedItemCliente!: ComboBase;

  public flagAdd: boolean = false;

  debounce: Subject<string> = new Subject<string>();

  listaFluxoTransicaoPorStatus: AtividadeFluxoTransicaoPorStatus[] = [];

  atividadeGrid!: AtividadeDetalhe;
  visible: boolean = false;
  latitudeAjustada: number | null = null;
  longitudeAjustada: number | null = null;

  eventosVisible: boolean = false;
  events: AtividadeEvents[] = [];

  checkDownload: boolean = false
  loading: boolean = false

  @ViewChild('containerImagens', { static: false })
  containerImagens!: ElementRef<HTMLDivElement>;
  imagens: HTMLImageElement[] = [];
  
  @ViewChild('checklistRef') checklistRef!: ElementRef;
  @ViewChild('formRef') formRef!: ElementRef;

  @Output() transformPDFEvent = new EventEmitter<boolean>();

    /**
   * Emite o `ToiAtivo` que veio no DetalheAtividade, para o container decidir se
   * precisa buscar o TOI. Evita a requisição a `MxlAtividadeToi/PorAtividade` em OS sem TOI.
   */
  @Output() toiAtivoChange = new EventEmitter<boolean>();
  // #endregion

  // #region Constructor
  constructor(
    private atividadeService: AtividadeService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private atividadeTipoService: AtividadeTipoService,
    private caracteristicaService: CaracteristicaService,
    // private clienteService: ClienteService,
    // private produtoService: ProdutoService,
    private messageService: MessageService,
    private googleService: GoogleApiService,
    private userService: UserService,
    // private atividadeCaracteristicaService: AtividadeCaracteristicaService
    private utilService: UtilService
  ) {}
  // #endregion Constructor

  // #region OnInit
  ngOnInit(): void {
    // this.flagAdd = this.userService.hasPermission('P_MAX') || this.userService.hasPermission('R_MF_SERVICO_EDT');
    this.imagesFieldsetCollapsed = true;
    this.findAtividadeById();

    this.atividadeAddForm = this.formBuilder.group(
      {
        idHierarquia: ['', Validators.required],
        idAcionamentoTipo: ['', Validators.required],
        idAcionamento: [''],
        idProvisorio: [''],
        idStatus: ['', Validators.required],
        numeroBa: ['', [Validators.maxLength(100)]],
        numeroBaOriginal: [],
        numeroDocumento: [],
        solicitante: [],
        idProduto: ['', Validators.required],
        siglaAtividadeCaracteristica: ['', Validators.required],
        idTipoAtividade: ['', Validators.required],
        idAtividadeClasse: ['', Validators.required],
        idAtividadeClassificacao: ['', Validators.required],
        tempoExecucaoPrevisto: ['', Validators.required],
        fatorEquivalente: ['', Validators.required],
        idCliente: ['', Validators.required],
        site: ['', [Validators.required, Validators.maxLength(100)]],
        descricao: ['', Validators.required],
        observacao: [''],
        endereco: ['', Validators.required],
        latitude: ['', Validators.required],
        longitude: ['', Validators.required],
        latitudeOriginal: [],
        longitudeOriginal: [],
        municipio: [],
        dataInicioAgendamento: [''],
        dataFimAgendamento: [''],
        limiteAtendimento: ['', Validators.required],
        //Cenario
        cenario_Prioridade: [],
        cenario_Tratamento: [],
        cenario_Tempo: [],
        cenario_Classificacao: [],
        cenario_SelecaoOS: [],
        ranqueamento: [],
      },
      {
      }
    );
  }
  // #endregion

  // #region OnDestroy
  ngOnDestroy(): void {
    this.debounce.unsubscribe();
  }
  // #endregion

  // #region Atividade
    /** API pode enviar `ToiAtivo` (PascalCase), `toiAtivo` ou string 'true'/'1'. */
  private resolverToiAtivo(atv: any): boolean {
    const raw = atv?.toiAtivo ?? atv?.ToiAtivo ?? atv?.flagToiAtivo ?? atv?.FlagToiAtivo;
    if (typeof raw === 'boolean') {
      return raw;
    }
    if (typeof raw === 'number') {
      return raw === 1;
    }
    if (typeof raw === 'string') {
      const v = raw.trim().toLowerCase();
      return v === 'true' || v === '1' || v === 's' || v === 'sim';
    }
    return false;
  }
  findAtividadeById() {
    if (!this.idAtividade || this.idAtividade === 0) {
      this.toiAtivoChange.emit(false);
      return;
    }

    this.atividadeService
      .findAtividadeById(this.idAtividade) //requisição alterada para o service na pasta service
      .subscribe(
        (atv: any) => {
          this.toiAtivoChange.emit(this.resolverToiAtivo(atv));
          this.atividade = atv;
          this.atividadeGrid = atv; //variavel do grid
          this.hierarquiaLabel = atv.unidadeOrg || '';
          this.idHierarquia = atv.idHierarquia ?? 0;
          this.tipoAcionamento = atv.tipoAcionamento || '';
          this.enderecoCliente = atv.endereco || '';
          this.latitudeCliente = atv.latitude ?? 0;
          this.longitudeCliente = atv.longitude ?? 0;

          this.atividade = atv;
        },
        (err: any) => {
          this.toiAtivoChange.emit(false);
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: 'Erro ao carregar dados da atividade',
            life: 3000
          });
        }
      );
  }

  verificarImagens(imagens: any[]) {

    this.imagens = [];
    this.imageContent = imagens.length > 0;
    this.loadImage = false;
    imagens.forEach(img => {
      if (img?.nomeArquivo) {
        const image = new Image();
        image.src = img?.nomeArquivo;
        image.alt = img?.nomeFoto ?? 'imagem';
        this.imagens.push(image);
      }
    });
  }



  updCoordenadas() {
    this.visible = true;
  }
  onClose() {
    this.visible = false;
  }

  onConfirmCoordenadas(idAtividade: any) {
    const body = {
      idAtividade: idAtividade,
      idCliente: this.atividade.idCliente,
      latitude: this.latitudeAjustada,
      longitude: this.longitudeAjustada,
    };

    this.atividadeService.updateCoordenadas(body).subscribe({
      next: (response) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Coordenadas alteradas com sucesso.',
          life: 3000,
        });
        this.findAtividadeById();
        this.visible = false;
        this.latitudeAjustada = null;
        this.longitudeAjustada = null;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao alterar Coordenadas.',
          life: 3000,
        });
      },
    });
  }



  // #region Hierarquia
  showDialogHierarquia() {
    this.dialogHierarquiaVisible = true;
  }

  reciverFeedbackHierarquia(treeNode: TreeNode) {
    this.idHierarquia = Number(treeNode.key);
    this.hierarquiaLabel = treeNode.label || '';
    this.dialogHierarquiaVisible = false;
    this.atividadeAddForm.controls['idHierarquia'].setValue(this.idHierarquia.toString());
  }

  geocodeCoordinates() {
    if (this.latitudeCliente == null || this.longitudeCliente == null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Pesquisa Endereço',
        detail: `Preencha a Latitude e a Longitude.`,
      });
      this.latitudeInput.nativeElement.focus();
    } else {
      const latlong = new google.maps.LatLng(this.latitudeCliente, this.longitudeCliente);
      this.googleService.geocode(latlong).subscribe((item) => {
        if (item.length > 0) {
          this.enderecoCliente = item[0].formatted_address;
          this.atividadeAddForm.controls['endereco'].setValue(this.enderecoCliente);
        } else {
          this.enderecoCliente = 'Nenhum endereço encontrado.';
        }
      });
    }
  }

  geocodeAddress() {
    if (this.enderecoCliente == '' || this.enderecoCliente == null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Pesquisa Coordenadas',
        detail: `Preencha o endereço.`,
      });
      this.enderecoInput.nativeElement.focus();
    } else {
      this.googleService.codeAddress(this.enderecoCliente).subscribe((item) => {
        if (item.length > 0) {
          this.atividadeAddForm.controls['latitude'].setValue(item[0].geometry.location.lat());
          this.atividadeAddForm.controls['longitude'].setValue(item[0].geometry.location.lng());
          if (this.enderecoCliente.length < item[0].formatted_address.length) {
            this.enderecoCliente = item[0].formatted_address;
            this.atividadeAddForm.controls['endereco'].setValue(item[0].formatted_address);
          }
        } else {
          this.enderecoCliente = 'Nenhum endereço encontrado.';
        }
      });
    }
  }

  onSearchChangeAddress(value: any) {
    this.enderecoCliente = value;
  }

  onSearchChangeLatitude(value: any) {
    this.latitudeCliente = value;
  }

  onSearchChangeLongitude(value: any) {
    this.longitudeCliente = value;
  }

  openEventos() {
    this.eventosVisible = true;
  }

  loadEvents(events: any) {
    this.events = [];
    if (events !== undefined) {
      this.events = events;
    }
  }

  transformPDF() {
    this.transformPDFEvent.emit(true);
  }

  obterDadosFormulario() {
    return {
      //Geral
      numeroBA: this.atividadeGrid.numeroBA,
      siglaAtvTipo: this.atividade?.siglaAtvTipo || '',
      descTipoAtividade: this.atividade?.descTipoAtividade || '',
      unidadeOrg: this.atividade?.unidadeOrg || '',
      status: this.atividade.status + ' (' + this.atividade.statusAtividade + ')',
      matricula_Imovel: this.atividade?.matricula_Imovel || '',
      visitasRealizadas: this.atividade?.visitasRealizadas || '',
      cliente: this.atividade?.cliente || '',
      geracaoOS: this.formatarDataHora(this.atividade?.geracaoOS || ''),
      endereco: this.atividade?.endereco || '',
      limiteAtendimento: this.atividade?.limiteAtendimento ? this.formatarDataHora(this.atividade.limiteAtendimento) : '',
      referencia: this.atividade?.referencia || '',
      solicitante: this.atividade?.solicitante || '',
      tel_Solicitante: this.atividade?.tel_Solicitante || '',
      equipe: this.atividade?.equipeResponsavel || '',
      responsavel: this.atividade?.responsavel || '',
      identificadorCliente: this.atividade?.identificadorCliente || '',
      setorRotaFaceSeq: this.atividade?.setorRotaFaceSeq || '',
      //Dados da Instalação
      tpSdeExecucao: this.atividade?.tpSdeExecucao || '',
      numeroDoPontoDeServico: this.atividade?.numeroDoPontoDeServico || '',
      numeroDoHidrometro: this.atividade?.numeroDoHidrometro || '',
      localizacaoDoPadrao: this.atividade?.localizacaoDoPadrao || '',
      dataInstalacao: this.formatarDataHora(this.atividade?.dataInstalacao) || '',
      situacaoDoImovelAgua: this.atividade?.situacaoDoImovelAgua || '',
      situacaoDoImovelEsgoto: this.atividade?.situacaoDoImovelEsgoto || '',
      situacaoDoPS: this.atividade?.situacaoDoPS || '',
      consumoMedioNoPs: this.atividade?.consumoMedioNoPs || '',
      ramoDeAtividadePrincipal: this.atividade?.ramoDeAtividadePrincipal || '',
      inicioExecucaoReal: this.atividade?.inicioExecucaoReal || '',
      fimExecucaoReal: this.atividade?.fimExecucaoReal || '',
      //Economias por Categoria
      tableEconomCategoria: this.atividadeGrid?.economiaPorCategorias.map((item) => [
        item.tps || '',
        item.comercial || '',
        item.industrial || '',
        item.publica || '',
        item.residencial || '',
        item.social || '',
      ]),
      //Economias por Categoria
      tableResumoPS: this.atividadeGrid?.resumoDePs.map((item) => [
        item.tps || '',
        item.situacaoPS || '',
        item.quantidade || '',
      ]),
      //Leituras do Imóvel
      tableLeituraImovel: this.atividadeGrid?.leiturasImovel.map((item) => [
        item.mesAnoLeitura || '',
        this.formatarDataHora(item.dataLeitura || ''),
        item.cfLeitura || '',
        item.volumeFaturado || '',
        item.leituraFaturado || '',
        item.caLeitura || '',
        item.ocorrenciaLeitura || '',
      ]),
      //Info Adicionais
      infoAdicionais: this.atividade?.infoAdicionais || '',

      //Débitos
      tableDebitos: this.atividadeGrid?.debitosCliente.map((item) => [
        item.dataReferencia || '',
        item.dataVencimento || '',
        item.valorFatura || '',
      ]),
    };
  }

  formatarDataHora(data: string | Date): string {
    const dataObj = new Date(data);
    return `${dataObj.toLocaleDateString('pt-BR')} ${dataObj.toLocaleTimeString('pt-BR')}`;
  }

  exportarZip() {
    this.utilService.exportarZip(this.imagens, 'Geral');
  }

  isToiMidiaOculta(midia: ToiMidiaItem, index: number): boolean {
    return this.midiasOcultasPdf.has(getToiMidiaKey(midia, index));
  }

  downloadConcluido(){
    this.checkDownload = false;
    this.loading = false
    this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fotos exportadas com sucesso!', life: 3000 });
  }

  gerarPdf(){
    if(!this.imageContent){
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Não há fotos para serem exportadas para o PDF.', life: 3000 });
      return
    }
    this.checkDownload = true;
    this.loading = true
    this.messageService.add({ severity: 'info', summary: 'Aguarde', detail: 'Exportando fotos para o PDF.', life: 3000 });
  }

}
